// @flow
import * as React from 'react'
import type { Question } from 'types/question'
import type { QuestionChoice } from 'types/question-choice'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import Modal from 'ui/atoms/Modal'

import BuilderCheckboxEditPropsContent from './BuilderCheckboxEditPropsContent'

type QuestionProps = {
  question_choices?: Array<QuestionChoice>,
  default_value?: ?string,
}
type Props = {
  questionId: number,
  question: Question,
  onUpdateQuestionProps: (props: QuestionProps) => void,
  mayRequestDetails?: boolean,
  assignValues?: boolean,
  onHide: () => void,
}

function BuilderCheckboxEditPropsModal({
  questionId,
  onUpdateQuestionProps,
  mayRequestDetails,
  assignValues,
  onHide,
  question,
}: Props): React.Node {
  return (
    <Modal
      blueHeader
      closeButton
      show
      onHide={onHide}
      title="Integration Values"
    >
      <BuilderCheckboxEditPropsContent
        includeIntegrationValues
        assignValues={assignValues}
        mayRequestDetails={mayRequestDetails}
        onUpdateQuestionProps={onUpdateQuestionProps}
        question={question}
        questionId={questionId}
      />
      <Flex justify="end">
        <Button $primary onClick={onHide}>
          Save
        </Button>
      </Flex>
    </Modal>
  )
}

export default BuilderCheckboxEditPropsModal
